import React from "react";

import Button from "../../base-components/button";
import utils from "./utils";
import classes from "./index.module.css";

import { setUserCurrentScreen } from "../../redux/action/app";
import { dashboard } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openShowHoldings, openFundingFail } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";
import { AccountStatus, DashboardAction } from "../../utilities/Variables";

const BuyWait = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);
  const onSubmit = () => {
    dispatch(dashboard({ action: DashboardAction.CheckStatus })).then(
      (response) => {
        const accountStatus = response?.account_status;
        if (
          accountStatus === AccountStatus.PortfolioCreated ||
          accountStatus === AccountStatus.WithdrawPending ||
          accountStatus === AccountStatus.WithdrawPartialSuccess ||
          accountStatus === AccountStatus.WithdrawSuccessful
        ) {
          dispatch(setUserCurrentScreen(config.routes.showHoldings));
          openShowHoldings();
        } else if (accountStatus === AccountStatus.PurchaseFail) {
          dispatch(setUserCurrentScreen(config.routes.fundingFail));
          openFundingFail();
        }
      }
    );
  };

  return (
    <div className={classes.Container}>
      <div className={classes.top}></div>
      <div className={classes.middle}>
        <h2 className={classes.Heading}>{utils.BUY_WAIT_HEADER}</h2>
        <p className={classes.SubHeading}>{utils.BUY_WAIT_SUBHEADING}</p>
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
        >
          {utils.BUY_WAIT_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default BuyWait;
